import React from 'react'
import SelectField from 'material-ui/SelectField'

const renderSelectField = ({
  input,
  label,
  meta: {touched, error},
  children,
  ...custom
}) => (
  <SelectField
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    onChange={(event, index, value) => input.onChange(value)}
    children={children}
    {...custom}
  />
)

export default renderSelectField



// WEBPACK FOOTER //
// ./src/components/fields/renderSelectField.js